import React, { Component } from "react";
import FormGroup from "../FormGroup/FormGroup";
import { _prettyPhone, _numbersOnly } from "assets/scripts/domain/profile/dataConversion";
import validPhone from "assets/scripts/utils/validPhone";
import isEmpty from "assets/scripts/utils/isEmpty";
function format(value) {
    if (validPhone(value)) {
        return _prettyPhone(value) || "";
    }
    return value;
}
class PhoneInput extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            focused: false,
            rawValue: ""
        };
        this._handleChange = this._handleChange.bind(this);
        this._handleFocus = this._handleFocus.bind(this);
        this._handleBlur = this._handleBlur.bind(this);
    }
    render() {
        const { props, state } = this;
        const value = state.focused ? state.rawValue : format(props.value);
        return (<input {...props.attrs} type="tel" className="textInput" value={value} onChange={this._handleChange} onFocus={this._handleFocus} onBlur={this._handleBlur}/>);
    }
    _handleChange(event) {
        let { value } = event.currentTarget;
        this.setState({ rawValue: value });
        if (validPhone(value)) {
            value = _numbersOnly(value);
        }
        else if (isEmpty(value)) {
            value = "";
        }
        this.props.onChange(value, event);
    }
    _handleFocus(event) {
        this.setState({
            focused: true,
            rawValue: format(this.props.value)
        });
        if (this.props.attrs.onFocus != null) {
            this.props.attrs.onFocus(event);
        }
    }
    _handleBlur(event) {
        this.setState({ focused: false });
        if (this.props.attrs.onBlur != null) {
            this.props.attrs.onBlur(event);
        }
    }
}
const PhoneFormGroup = (props) => (<FormGroup {...props}>
		{(controlState) => <PhoneInput {...controlState}/>}
	</FormGroup>);
export default PhoneFormGroup;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/PhoneFormGroup/PhoneFormGroup.tsx